export default {
    zh: {
        current_cost: '本次生成消耗',
        discount_percent: `已享会员{discount}折`,
        standard_price: '标准价格',
        vip_has_half_price: '会员立享首单半价',
        start_vip: '开通',
        vip_has_half_price_short: '首单半价',
        start_vip_short: 'VIP',
    },
    en: {
        current_cost: 'Cost this time',
        discount_percent: 'VIP discount: {discount}',
        standard_price: 'Standard price',
        vip_has_half_price: 'VIP: 50% off your first order',
        start_vip: 'Upgrade',
        vip_has_half_price_short: '-50% first order',
        start_vip_short: 'VIP',
    },
    ja: {
        current_cost: '今回の生成コスト',
        discount_percent: '会員割引：{discount}',
        standard_price: '通常価格',
        vip_has_half_price: '会員は初回半額',
        start_vip: 'アップグレード',
        vip_has_half_price_short: '初回半額',
        start_vip_short: 'VIP',
    },
    ko: {
        current_cost: '이번 생성 비용',
        discount_percent: 'VIP 할인: {discount}',
        standard_price: '정상가',
        vip_has_half_price: 'VIP 첫 주문 50% 할인',
        start_vip: '업그레이드',
        vip_has_half_price_short: '첫 주문 50%',
        start_vip_short: 'VIP',
    },
    tw: {
        current_cost: '本次生成消耗',
        discount_percent: '會員折扣：{discount}',
        standard_price: '標準價格',
        vip_has_half_price: '會員立享首單半價',
        start_vip: '升級',
        vip_has_half_price_short: '首單半價',
        start_vip_short: 'VIP',
    },
    es: {
        current_cost: 'Costo de esta generación',
        discount_percent: 'Descuento VIP: {discount}',
        standard_price: 'Precio estándar',
        vip_has_half_price: 'VIP: 50% en tu 1er pedido',
        start_vip: 'Actualizar',
        vip_has_half_price_short: '-50% 1er pedido',
        start_vip_short: 'VIP',
    },
    fr: {
        current_cost: 'Coût de cette génération',
        discount_percent: 'Remise VIP : {discount}',
        standard_price: 'Prix standard',
        vip_has_half_price: 'VIP : -50% 1re commande',
        start_vip: 'Passer VIP',
        vip_has_half_price_short: '-50% 1re cmd.',
        start_vip_short: 'VIP',
    },
    de: {
        current_cost: 'Kosten für diese Generierung',
        discount_percent: 'VIP-Rabatt: {discount}',
        standard_price: 'Standardpreis',
        vip_has_half_price: 'VIP: 50% auf 1. Bestellung',
        start_vip: 'Upgraden',
        vip_has_half_price_short: '-50% 1. Bestellung',
        start_vip_short: 'VIP',
    },
    ru: {
        current_cost: 'Стоимость этой генерации',
        discount_percent: 'Скидка VIP: {discount}',
        standard_price: 'Стандартная цена',
        vip_has_half_price: 'VIP: -50% на 1-й заказ',
        start_vip: 'Оформить VIP',
        vip_has_half_price_short: '-50% 1-й заказ',
        start_vip_short: 'VIP',
    },
    pt: {
        current_cost: 'Custo desta geração',
        discount_percent: 'Desconto VIP: {discount}',
        standard_price: 'Preço padrão',
        vip_has_half_price: 'VIP: 50% no 1o pedido',
        start_vip: 'Fazer upgrade',
        vip_has_half_price_short: '-50% 1o pedido',
        start_vip_short: 'VIP',
    },
    it: {
        current_cost: 'Costo di questa generazione',
        discount_percent: 'Sconto VIP: {discount}',
        standard_price: 'Prezzo standard',
        vip_has_half_price: 'VIP: 50% sul 1o ordine',
        start_vip: 'Upgrade',
        vip_has_half_price_short: '-50% 1o ordine',
        start_vip_short: 'VIP',
    },
    ar: {
        current_cost: 'تكلفة هذه العملية',
        discount_percent: 'خصم VIP: {discount}',
        standard_price: 'السعر القياسي',
        vip_has_half_price: 'VIP: خصم 50% لأول طلب',
        start_vip: 'الترقية',
        vip_has_half_price_short: 'خصم 50% لأول طلب',
        start_vip_short: 'VIP',
    },
    th: {
        current_cost: 'ค่าใช้จ่ายการสร้างนี้',
        discount_percent: 'ส่วนลด VIP: {discount}',
        standard_price: 'ราคามาตรฐาน',
        vip_has_half_price: 'VIP: ลด 50% ออเดอร์แรก',
        start_vip: 'อัปเกรด',
        vip_has_half_price_short: 'ลด 50% ออเดอร์แรก',
        start_vip_short: 'VIP',
    },
    da: {
        current_cost: 'Kost for denne generering',
        discount_percent: 'VIP-rabat: {discount}',
        standard_price: 'Standardpris',
        vip_has_half_price: 'VIP: 50% på 1. ordre',
        start_vip: 'Opgrader',
        vip_has_half_price_short: '-50% 1. ordre',
        start_vip_short: 'VIP',
    },
    no: {
        current_cost: 'Kost for denne generering',
        discount_percent: 'VIP-rabat: {discount}',
        standard_price: 'Standardpris',
        vip_has_half_price: 'VIP: 50% på 1. ordre',
        start_vip: 'Opgrader',
        vip_has_half_price_short: '-50% 1. ordre',
        start_vip_short: 'VIP',
    },
    nl: {
        current_cost: 'Kost voor deze generatie',
        discount_percent: 'VIP-korting: {discount}',
        standard_price: 'Standaardprijs',
        vip_has_half_price: 'VIP: 50% op je 1e order',
        start_vip: 'Upgrade',
        vip_has_half_price_short: '-50% 1e order',
        start_vip_short: 'VIP',
    },
    id: {
        current_cost: 'Biaya generasi ini',
        discount_percent: 'Diskon VIP: {discount}',
        standard_price: 'Harga standar',
        vip_has_half_price: 'VIP: Diskon 50% pesanan 1',
        start_vip: 'Upgrade',
        vip_has_half_price_short: 'Diskon 50% pesanan 1',
        start_vip_short: 'VIP',
    },
    tr: {
        current_cost: 'Bu bu generasyon maliyeti',
        discount_percent: 'VIP indirimi: {discount}',
        standard_price: 'Standart fiyat',
        vip_has_half_price: 'VIP: İlk siparişe %50 indirim',
        start_vip: 'Yükselt',
        vip_has_half_price_short: 'İlk siparişe %50',
        start_vip_short: 'VIP',
    },
}
